import { call, getContext, put, select, cancel } from 'redux-saga/effects';
import { loadPublishTermsStart, loadPublishTermsSuccess, loadPublishTermsFail } from '../../../reducers';
import { getPublishTerms as getPublishTermsService, TGetPublishTermsResult } from '../../../../services/publishTerms';
import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api/shared';
import { getParameters, isParametersValid } from './utils';
import { IAppState } from '../../../types';
import { selectIsNewPublishTermsEnabled } from '../../../../selectors/publishTerms';
import { selectIsPublishToHiddenBase } from '../../../../selectors/publishAvailable';
import { TLoadPublishTermsResult, TMicrofrontendsAPI } from '../../../../types/microfrontends/buyPackage';

export function* getPublishTerms() {
  try {
    const config: IConfig = yield getContext('config');
    const state: IAppState = yield select();
    const microfrontendsApi: TMicrofrontendsAPI = yield getContext('microfrontendsApi');

    const isServicePickerWidgetEnabled = config.get<boolean>('addFormFrontend.ServicePickerWidget.isEnabled') || false;

    if (isServicePickerWidgetEnabled) {
      microfrontendsApi.setOffer(state.offer);
      microfrontendsApi.setUser(state.user);

      const data: TLoadPublishTermsResult | null = yield call(microfrontendsApi.loadPublishTerms);

      if (data && data.success) {
        yield put(loadPublishTermsSuccess(data.payload));
      } else {
        yield put(loadPublishTermsFail());
      }

      return;
    }

    const logger: ILogger = yield getContext('logger');
    const httpApi: IHttpApi = yield getContext('httpApi');

    const isNewPublishTermsEnabled = selectIsNewPublishTermsEnabled(config, state);
    const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

    if (!isNewPublishTermsEnabled || isPublishToHiddenBase) {
      yield cancel();
    }

    yield put(loadPublishTermsStart());

    const parameters = getParameters(state);

    if (!isParametersValid(parameters)) {
      yield put(loadPublishTermsFail());
      yield cancel();
    }

    const response: TGetPublishTermsResult = yield call(getPublishTermsService, {
      httpApi,
      logger,
      parameters,
    });

    if (response.success) {
      yield put(loadPublishTermsSuccess(response.payload));
    } else {
      yield put(loadPublishTermsFail(response.payload));
    }
  } catch (e) {
    yield put(loadPublishTermsFail());

    throw new Error(e.toString());
  }
}
